import React, { useState } from 'react';
import { ReactComponent as EditPen } from '../../../assets/icons/EditPen.svg';
import { ReactComponent as DeleteX } from '../../../assets/icons/DeleteX.svg';
import { ReactComponent as Details } from '../../../assets/icons/Details.svg';
import { Form, Button } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ClientOnExcursionService from '../../../repository/clientOnExcursionRepository/ClientOnExcursionRepository';
import Swal from 'sweetalert2';
import swal from 'sweetalert';
import ClientPaymentHistoryModal from './ClientPaymentHistory/ClientPaymentHistoryModal';
import { strings } from '../../../localization/Localization';
import { useAuth } from '../../Auth/AuthContext';

const ClientExcursionHistory = ({
  client,
  excursionsHistory,
  loading,
  onFetchExcursionHistory,
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
  fetchClientForPointsUpdate
}) => {
  const [editIndex, setEditIndex] = useState(null);
  const [editedData, setEditedData] = useState({
    id: null,
    discount: '',
    pointsUsed: '',
    extraExpenses: '',
  });

  const [selectedExcursionHistory, setSelectedExcursionHistory] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { isAdmin } = useAuth();

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value) || 5;
    onPageSizeChange(newSize);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedExcursionHistory([]);
    setShowModal(false);
  };

  const handleEditClick = (index, rowData) => {
    setEditIndex(index);
    setEditedData({
      id: rowData.id,
      discount: rowData.discount,
      extraExpenses: rowData.extraExpenses,
    });
  };

  const handleSubmitClick = async () => {
    try {
      await ClientOnExcursionService.updateExcursionHistory(
        editedData.id,
        editedData.discount,
        editedData.extraExpenses,
      );
      onFetchExcursionHistory(client.id, page, pageSize, 'createdAt', 'desc');
      setEditIndex(null);
    } catch (error) {
      console.error('Error updating excursion history:', error);
    }
  };

  const deletedSuccessfullyAlert = () => {
    Swal.fire({
      icon: 'success',
      title: strings.deletedSuccessfully,
    });
  };

  const errorAlert = () => {
    swal({
      title: strings.somethingWentWrong,
      icon: 'error',
      dangerMode: true
    });
  };

  const deleteClientOnExcursion = (idClientOnExcursion) => {
    ClientOnExcursionService.deleteClientOnExcursion(idClientOnExcursion)
      .then(() => {
        deletedSuccessfullyAlert();
        onFetchExcursionHistory(client.id);
      }).catch(() => {
      errorAlert();
    });
  };

  const ConfirmationDelete = (id) => {
    Swal.fire({
      title: strings.confirmationDelete,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteClientOnExcursion(id);
      }
    });
  };

  const handleExport = async () => {
    try {
      const response = await ClientOnExcursionService.exportExcursionHistory(client.id);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `excursion_history_for_${client.name}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: 'success',
        title: strings.exportSuccessful,
      });
    } catch (error) {
      console.error('Error exporting excursion history:', error);
      Swal.fire({
        icon: 'error',
        title: strings.exportFailed,
      });
    }
  };

  const handleRefreshExcursionHistory = () => {
    onFetchExcursionHistory(client.id, page, pageSize, 'createdAt', 'desc');
  };

  return (
    <>
      <ClientPaymentHistoryModal
        showModal={showModal}
        handleClose={handleCloseModal}
        selectedExcursionHistory={selectedExcursionHistory}
        onDataUpdate={handleRefreshExcursionHistory}
        fetchClientForPointsUpdate={fetchClientForPointsUpdate}
      />
      <div className='bg-light p-3 rounded shadow-sm'>
        <div className='row'>
          <h4 className='col-8'>{strings.excursionHistory} </h4>
          <div className='col-2'>
            <div className='d-flex'>
              <span>{strings.paginationSize}</span>
              <input
                className='form-control form-control-sm'
                type='number'
                min='1'
                value={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: '80px' }}
              />
            </div>
          </div>
          {isAdmin && (
            <div className='col-2 d-flex justify-content-end'>
              <button
                className='btn btn-danger px-3 rounded-4'
                onClick={handleExport}
              >
                {strings.export}
              </button>
            </div>
          )}
        </div>
        <hr className='my-1'/>

        {loading ? (
          <p className='text-center text-secondary'>{strings.loadingExcursions}</p>
        ) : (
          <>
            <table className='table user-table table-responsive table-borderless table-striped mb-1 mt-3'>
              <thead className='table-header-css'>
              <tr className='rounded-4'>
                <th>{strings.details}</th>
                <th>{strings.excursionName}</th>
                <th>{strings.excursionPrice}</th>
                <th>{strings.excursionDiscount}</th>
                <th>{strings.additionalDiscount}</th>
                <th>{strings.pointsUsed}</th>
                <th>{strings.pointsGained}</th>
                <th>{strings.extraExpenses}</th>
                <th>{strings.finalPrice}</th>
                <th>{strings.paidPrice}</th>
                <th>{strings.note}</th>
                <th>{strings.actions}</th>
              </tr>
              </thead>
              <tbody>
              {excursionsHistory.length > 0 ? (
                excursionsHistory.map((object, index) => (
                  <tr key={index}>
                    <td>
                      <a className='cursor-pointer' onClick={() => {
                        setSelectedExcursionHistory(object);
                        handleShowModal();
                      }}>
                        <Details width='25px' height='25px'/>
                      </a>
                    </td>
                    <td>{object.excursion.name}</td>
                    <td>{object.excursion.price}</td>
                    <td>{object.excursionDiscount}</td>
                    <td>
                      {editIndex === index ? (
                        <Form.Control
                          type='text'
                          value={editedData.discount}
                          onChange={(e) => setEditedData({
                            ...editedData,
                            discount: e.target.value
                          })}
                        />
                      ) : (
                        object.discount
                      )}
                    </td>
                    <td>{object.pointsUsed}</td>
                    <td>{object.pointsGained}</td>
                    <td>
                      {editIndex === index ? (
                        <Form.Control
                          type='text'
                          value={editedData.extraExpenses}
                          onChange={(e) => setEditedData({
                            ...editedData,
                            extraExpenses: e.target.value
                          })}
                        />
                      ) : (
                        object.extraExpenses
                      )}
                    </td>
                    <td>{object.finalPrice}</td>
                    <td>{object.paidPrice}</td>
                    <td style={{ cursor: 'default' }}>
                      <OverlayTrigger
                        placement='top'
                        overlay={
                          <Tooltip id={`tooltip-${index}`}>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{object.note}</div>
                          </Tooltip>
                        }
                      >
                      <span
                        style={{
                          display: 'inline-block',
                          maxWidth: '150px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          verticalAlign: 'middle'
                        }}
                      >
                        {object.note}
                      </span>
                      </OverlayTrigger>
                    </td>

                    <td>
                        <span className='d-flex justify-content-center'>
                          {editIndex === index ? (
                            <>
                              <Button variant='primary' size='sm' className='me-2' onClick={handleSubmitClick}>
                                {strings.submit}
                              </Button>
                              <Button variant='secondary' size='sm' onClick={() => setEditIndex(null)}>
                                {strings.cancel}
                              </Button>
                            </>
                          ) : (
                            <>
                              <a className='cursor-pointer' onClick={() => handleEditClick(index, object)}>
                                <EditPen width='25px' height='25px'/>
                              </a>
                              <a className='cursor-pointer' onClick={() => {
                                ConfirmationDelete(object.id);
                              }}>
                                <DeleteX width='25px' height='25px'/>
                              </a>
                            </>
                          )}
                        </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className='text-center my-5'>
                  <td colSpan='12' className='text-secondary no-notification-message'>
                    {strings.noExcursionsForClient}
                  </td>
                </tr>
              )}
              </tbody>
            </table>

            <div className='d-flex justify-content-center gap-2 mt-3'>
              <button
                className='btn btn-sm btn-outline-secondary'
                disabled={page === 0}
                onClick={() => onPageChange(page - 1)}
              >
                ← {strings.previous}
              </button>
              <span className='mx-3 align-self-center'>
                {strings.page} {page + 1} {strings.of} {totalPages}
              </span>
              <button
                className='btn btn-sm btn-outline-secondary'
                disabled={page + 1 >= totalPages}
                onClick={() => onPageChange(page + 1)}
              >
                {strings.next} →
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ClientExcursionHistory;
